module.exports = __webpack_public_path__ + "img/analysis-cash.7927633a.svg";